import React from "react";

const IconComment = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M10 22.164l6.648-5.657c.393-.289 1.024-.878 1.65-1.71C19.359 13.39 20 11.781 20 10a8 8 0 1 0-16 0 7.996 7.996 0 0 0 6 7.739v4.425zm2-6.11l-.858-.124A5.995 5.995 0 0 1 12 4a6 6 0 0 1 6 6c0 1.302-.482 2.509-1.299 3.593a7.975 7.975 0 0 1-.916 1.02c-.181.17-.316.28-.38.328L12 17.837v-1.784z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default IconComment;
